<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> ສະໝັກເຂົ້າເປັນສະມາຊິກ ທຸລະກິດກະສິກຳລາວ</span>
        </div>
          
      </div>  
      <b-tabs v-model="activeTab" >
        
        
        <b-tab-item label="ລາຍການສະມາຊິກ" >
          <div class="columns" v-if="participateList.length > 0">  
            <div class="column">
              <b-field grouped>
                <b-field >
                ຄົ້ນຫາ
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ຊື່ ຫຼື ນາມສະກຸນ"
                    v-model.trim="searchByFullName"
                    @input="searchData(1)"  
                    type="text"
                  >  
                  </b-input>
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ເບີໂທ"
                    v-model.trim="searchByPhoneno"
                    type="text"
                    @input="searchData(2)"  
                  >  
                  </b-input>
                </b-field>
                <b-field >
                  <b-input
                  
                    placeholder="ເລກລົງທະບຽນ"
                    v-model.trim="searchByRegisterID"
                    type="text"
                    @input="searchData(3)"  
                  >  
                  </b-input>
                </b-field>
               
              </b-field>
                
            </div>
          </div>

         
          <div class="columns" v-if="participateList.length > 0">  
            <div class="column">
            </div>
            <div class="column">
            </div>
            <div class="column">
              <b-button 
                  class="btn-group-margin is-fullwidth"
                  type="is-primary"  
                  @click="openParticipateForm"
                  >  <span >ລົງທະບຽນ</span>
              </b-button>
            </div>
          </div>
          <table class="table is-fullwidth is-narrow is-small">
            <thead>
              <tr>
                <th class="has-text-left " width="5%">
                  RegNo
                </th>
                <th class="has-text-left " width="15%">
                  ຊື່ ແລະ ນາມສະກຸນ
                </th>
                <th class="has-text-left " width="10%">
                  ກຸ່ມທຸລະກິດ
                </th>
                <th class="has-text-left " width="10%">
                  ທຸລະກິດ
                </th>
                <th class="has-text-left " width="5%">
                  ເບີໂທ
                </th>
                <th class="has-text-centered " width="10%">
                  ລາຍລະອຽດ 
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data) in filteredParticipateList "
                :key="data.ID"
              >
                <td class="has-text-left " >
                  <span >
                    {{data.ID}}
                  </span>
                  
                </td>
                <td class="has-text-left " >
                  
                  {{ data.FULLNAME }}
                </td>
                <td class="has-text-left " >
                  {{ data.BUSINESSGROUP }}
                </td>
                <td class="has-text-left " >
                  {{ data.BUSINESSNAME }}
                </td> 
                <td class="has-text-left " >
                  {{ data.PHONENO }}
                </td> 
                <td class="centered-content"  >
                    <b-field>           
                      <b-button 
                          class="btn-group-margin is-fullwidth"
                          type="is-info"  
                          size="is-small"
                          @click="getParticipateDetail(data)"
                          >  <span > ລາຍລະອຽດ</span>
                      </b-button>
                    </b-field>
                  
                </td>
              </tr>
            </tbody>
            
          </table>

        </b-tab-item>
        <b-tab-item label="ຟອມລົງທະບຽນສະມາຊິກ" style="">
          
          <div class="columns" >
            <div class="column">
              

              <div class="columns" >
                <div class="column">
                  <b-field label="ຊື່ ແລະ ນາມສະກຸນ">
                    <b-input
                      v-model.trim="selectedFullName"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns" >
                <div class="column">
                  <b-field label="ອາຍຸ">
                    <b-input
                      v-model.trim="selectedAge"
                      type="text"
                    >  
                    </b-input>
                   
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພດ">
                    <Multiselect     
                      placeholder="ເພດ"
                      v-model.trim="selectedGender"
                      label="NAME"
                      track-by="ID"
                      :options="genderList"   
                    ></Multiselect>
                  </b-field>
                </div>
              </div>

              <div class="columns" >
                <div class="column">
                  <b-field label="ພາກສ່ວນ (ຖ້າມີ)">
                    <b-input
                      v-model.trim="selectedOrganization"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຕຳແໜ່ງ (ຖ້າມີ)">
                    <b-input
                      v-model.trim="selectedPosition"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <b-field label="ກຸ່ມທຸລະກິດ">
                    <Multiselect     
                      placeholder="ກຸ່ມທຸລະກິດ"
                      v-model.trim="selectedBusinessGroup"
                      label="NAME"
                      track-by="ID"
                      :options="businessGroupList"   
                    ></Multiselect>
                  </b-field>
                </div>
              </div>
              <div class="columns" >
                <div class="column">
                  <b-field label="ຊື່ທຸລະກິດ">
                    <b-input
                      v-model.trim="selectedBusinessName"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns" >
                <div class="column">
                  <b-field label="ເບີໂທຕິດຕໍ່">
                    <b-input
                      v-model.trim="selectedPhoneNo"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="" style="margin-top: 30px;">
                    <b-button  v-if="isEditForm==1"
                        class="btn-group-margin is-fullwidth"
                        type="is-danger"  
                        @click="doEditRegister()"
                        >  <span > ແກ້ໄຂຂໍ້ມູນ</span>
                    </b-button>
                    <b-button v-else
                        class="btn-group-margin is-fullwidth"
                        type="is-success"  
                        @click="doregister(1)"
                        >  <span > ລົງທະບຽນ</span>
                    </b-button>
                  </b-field>
                </div>
              </div>

              
            
              
              
              
            </div>
              
            <div class="column">
              
            </div>
            
              
          </div>

        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ" >
          <div class="columns" v-if="participateFullname">
            <div class="column">
              <div class="columns" >
                <div class="column">
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="title16">{{ participateFullname }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="title16">{{ participateAge }} </span> <span  class="title16-light">ປີ </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="title16">{{ participateGender }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ/ ຕຳແໜ່ງ: </span><span  class="title16">{{ participateOrganization }}/ {{ participatePosition }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ກຸ່ມທຸລະກິດ: </span><span  class="title16">{{ participateBusinessGroup }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ຊື່ທຸລະກິດ: </span><span  class="title16">{{ participateBusinessName }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="title16">{{ participatePhoneNo }} </span>
                  </b-field>

                  <b-field v-if="participateFullname" style="margin-top: 30px;">
                    <img :src="qrCodeUrl" alt="QR Code" />
                  </b-field>
                </div>
              
              </div>

              
              
            </div>
              
            <div class="column">
              
            </div>
            
              
          </div>
        </b-tab-item>
        
      </b-tabs>
      

      
    </div>


    

    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect },

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      selectedBusinessType: null,
      selectedBusiness: null,
      businessTypeList: [],

      participateList: [],

      filteredParticipateList: [],

      
      
      selectedFullName: null,
      selectedAge: null,
      genderList: [],
      selectedGender: null,
      selectedPhoneNo: null,

      participateFullname: null,
      participateAge: null,
      participateGender: null,
      participateSection: null,
      participatePhoneNo: null,
      participateStatus: null,

      qrData: null,

      registerQR: "https://lababiz.com/#/association/associationFormbySelf",

      

      eventTitle: null,

      searchByFullName: null,
      searchByPhoneno: null,
      searchByRegisterID: null,

      selectedEventtype: 0,

      selectedBusinessDescription: null,

      selectedInterestedList: null,
      
      selectedBusinessGroup: null,
      businessGroupList: [],

      selectedOrganization: null,
      selectedPosition: null,

      isEditForm: 0,

      selectedBusinessName: null,

      participateBusinessGroup: null,

      participateOrganization: null,
      participatePosition: null,
    };
     
    
  },
  methods: {    
    
    doregister(){
      // console.log("type: " + type)

      if(  !this.selectedFullName || this.selectedFullName === null || 
            !this.selectedAge || this.selectedAge === null ||  
            !this.selectedGender || this.selectedGender === null || 
            !this.selectedBusinessGroup || this.selectedBusinessGroup === null ||
            !this.selectedBusinessName || this.selectedBusinessName === null ||
            !this.selectedPhoneNo || this.selectedPhoneNo=== null )     {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
              return false;
      }
      
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params= {
                organization: this.selectedOrganization,
                position: this.selectedPosition,
                fullname: this.selectedFullName,
                age: this.selectedAge,
                gender: this.selectedGender.ID,
                businessgroup: this.selectedBusinessGroup.ID,
                businessname: this.selectedBusinessName,
                phoneno: this.selectedPhoneNo,
                self: 0,
                username: this.username,  
            };
            
            // console.log("params: "+JSON.stringify(params))  
            
            RestAPI.doMemberRegister(params) 
              .then((res) => {

                  if(res.data.responseData.data=== 'Duplicate phoneno'){
                    this.$swal("ເບີໂທລະສັບ ໄດ້ຖືກນຳໃຊ້ແລ້ວ, ກະລຸນາກວດຄືນ", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data=== 'Duplicate record'){
                    this.$swal("ລາຍການຊ້ຳ, ກະລຸນາກວດຄືນ", "", "warning");
                    return;
                  }

                  

                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ລົງທະບຽນ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });

                  this.getMemberList();

                  this.selectedOrganization = null;
                  this.selectedPosition = null;
                  this.selectedFullName = null;
                  this.selectedAge = null;
                  this.selectedGender = null;
                  this.selectedPhoneNo = null;
                  this.selectedBusinessGroup = null;

                  // this.getEventDetail(this.selectedEventData);
                  // this.activeTab = 1;

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });
      
    },
    
    getMemberList(){ 
      var params= {
            username: this.username,  
        };

      RestAPI.getMemberList(params)
        .then((res) => {
   
            this.participateList = res.data.responseData.data;
            this.filteredParticipateList = res.data.responseData.data;
          

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      
    },

    openParticipateForm(){
      this.activeTab = 1;
    },

    // loadData(){
    //   this.filteredParticipateList = this.participateList;

    // },

    searchData(type){
      if(type ==1){
        this.searchByPhoneno = null;
        this.searchByRegisterID = null;
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.FULLNAME.toLowerCase().includes(this.searchByFullName.toLowerCase());
        });
      }
      else if(type ==2){
        this.searchByFullName = null;
        this.searchByRegisterID = null;
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.PHONENO.toLowerCase().includes(this.searchByPhoneno.toLowerCase());
        });
      }else if(type ==3){
        this.searchByFullName = null;
        this.searchByPhoneno = null;
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.ID.toString().toLowerCase().includes(this.searchByRegisterID.toLowerCase());
        });
      }

      

      
    },
    
    getParticipateDetail(data){
      this.activeTab = 2; 
      this.participateFullname = data.FULLNAME;
      this.participateAge = data.AGE;
      this.participateGender = data.GENDERTITLE;
      this.participatePhoneNo = data.PHONENO;
      this.participateStatus=  data.STATUS;
      this.participateBusinessGroup = data.BUSINESSGROUP;
      this.participateBusinessName = data.BUSINESSNAME;
      this.participateOrganization = data.ORGANIZATION;
      this.participatePosition = data.POSITION;

      this.qrData = data.ID + " | " + data.FULLNAME + " | " + data.BUSINESSNAME;
    },
    
    getBusinessGroup() {
      RestAPI.getBusinessGroup()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.businessGroupList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getGender() {
      RestAPI.getGender()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.genderList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    // this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    this.username = this.user.USERNAME;   

    this.currentDate = new Date();
    // this.loadData();

    this.getGender();
    this.getBusinessGroup();
    this.getMemberList();



    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },

    registerQRCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.registerQR)}`;
    },
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.status-3 {
  background-color: #4FC3F7; /* Light blue for status 3 */
  color: white;
}

.status-2 {
  background-color: #B3E5FC; /* Lighter blue for status 2 */
  color: black;
}

.status-0 {
  background-color: #CFD8DC; /* Gray for status 0 */
  color: black;
}

.status-default {
  background-color: transparent; /* Default styling */
  color: inherit;
}

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
